/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.badgesModule')
.controller('BadgeContainerController', ['authorAccount', 'userBadgeInfo', '$scope', '$state', '$timeout', 'BulbAuthService',
  'BulbBusyService', 'BulbErrorService', 'BulbModalService', 'Restangular', BadgeContainerController]);

/**
 * AngularJS controller for badges.
 */
function BadgeContainerController(authorAccount, userBadgeInfo, $scope, $state, $timeout, BulbAuthService,
                  BulbBusyService, BulbErrorService, BulbModalService, Restangular) {

  var that = this;

  /*
  Accordion information for Foundation, checks to make sure they have badges, if not, give them an empty badge
  array only for the user's own account (to allow them to activate badges, it must be blank). If they don't have
  badges activated at all and someone else is accessing, make sure to send a 404 page via badge.js.
  */

  if (userBadgeInfo) {
    that.accordion = {
      oneAtATime: false,
      groups: userBadgeInfo.badgeGroups
    };
  } else {
    that.accordion = {
      oneAtATime: false,
      groups: []
    };
  }

  // Account information for breadcrumb and other such information (such as not being a pro member).
  this.userInfo = authorAccount;

  // This function opens all accordions on the Badge page by default, and is immediately run at init. 
  function openAllAccordions() {
    $timeout(function() {
      $('.bulb-badges-accordion-group a').click();
    });
  }

  openAllAccordions();

  // Determines whether or not the currently active user can refresh the badges on the viewed badges page. Basically,
  // it means only the author/owner of the badges should be able to click/see the Refresh Badges button.
  this.canRefreshBadges = function() {
    return that.userInfo.id === BulbAuthService.currentUser.id;
  };

  // This is what actually toggles the chevron from up to down or vice versa, and this is called whenever the badge
  // group header, or the chevron itself is clicked.
  this.toggleChevron = function(groupId) {
    $('#chevron_for_' + groupId).toggleClass('rot180');
  };

  // Modal options for the add badges modal
  var addBadgesModalOptions = {
    templateUrl: 'badges.addBadges.nested',
    windowClass: 'bulb-badgenotfound-modal',
    showTitle: false,
    showCancelButton: false,
    showOkButton: false,
    controller: 'AccountAddBadgeModalController as accountAddBadgeModalCtrl'
  };

  // Shows the add Badges modal
  this.showAddBadgesModal = function() {
    BulbModalService.show(addBadgesModalOptions);
  };

  // Cancels the adding badges process
  this.cancelAddBadgesModal = function() {
    $scope.$dismiss('cancel');
  };

  this.manuallyRefreshBadges = function() {
    // Activates the badges service and sets the current groups equal to the variable groups for instant display.
    BulbBusyService.showBusyDuring(Restangular.one('accounts', BulbAuthService.currentUser.id).one('badges').post()
      .then(function(badges) {
        if (badges) {
          $state.reload();
        } else {
          that.showBadgeMissingModal();
        }
      }).catch(function(e) {
        BulbErrorService.error('Cannot update the user badges', e);
      }));
  };

  // Modal options for the badges not found modal
  var notFoundModalOptions = {
    okButtonCode: 'button_ok',
    bodyCode: 'badge_modal_no_more_badges_text',
    windowClass: 'bulb-badgenotfound-modal',
    showTitle: false,
    showCancelButton: false
  };

  // Shows the modal on click
  this.showBadgeMissingModal = function() {
    BulbModalService.show(notFoundModalOptions);
  };
}

